import React from "react";
import styles from "./FileIcon.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileAlt,
  faFileImage,
  faFileVideo,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

function FileIcon({ file, removeFile }) {
  let icon;
  if (file.type.includes("image")) {
    icon = (
      <FontAwesomeIcon
        className={styles.uploadIcon}
        icon={faFileImage}
        size="2x"
      />
    );
  } else if (file.type.includes("video")) {
    icon = (
      <FontAwesomeIcon
        className={styles.uploadIcon}
        icon={faFileVideo}
        size="2x"
      />
    );
  } else {
    icon = (
      <FontAwesomeIcon
        className={styles.uploadIcon}
        icon={faFileAlt}
        size="2x"
      />
    );
  }

  return (
    <div className={styles.fileContainer}>
      <div className={styles.fileContainer}>
        <button
          onClick={(event) => {
            event.preventDefault();
            removeFile(file);
          }}
          aria-label={`Remove file ${file.name}`}
          className={styles.closeLink}
        >
          <FontAwesomeIcon
            className={styles.closeIcon}
            icon={faTimes}
            size="xs"
          />
        </button>

        {icon}
      </div>
      <span className={styles.fileName}>{file.name}</span>
    </div>
  );
}

export default FileIcon;
